import { render, staticRenderFns } from "./ChannelRequest.vue?vue&type=template&id=db353244&scoped=true&"
import script from "./ChannelRequest.vue?vue&type=script&lang=js&"
export * from "./ChannelRequest.vue?vue&type=script&lang=js&"
import style0 from "./ChannelRequest.vue?vue&type=style&index=0&id=db353244&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db353244",
  null
  
)

export default component.exports